$(document).ready(function () {
  // události při načtení stránky
  $(window).on('load', function () {
    // AOS fix pro první načítání
    // AOS.refresh();
  });

  // události při scroolování
  $(window).on('scroll', function () {});

  // modal okna
  if ($('.modal').length) {
    modal();
  }

  // youtube video v modálním okně
  if ($('.js-video-start').length) {
    //new ModalVideo('.js-video-start', { channel: 'youtube' });
    $('.js-video-start').modalVideo({
      youtube: {
        controls: 1,
        autoplay: 1,
      },
    });
  }

  // galerie
  if ($('.gallery').length) {
    $('.gallery a').simpleLightbox({
      showCounter: false,
    });
  }
});
